// extracted by mini-css-extract-plugin
module.exports = {"root":"TaggedImage_root__q_9Rj","image":"TaggedImage_image__benXk","tag":"TaggedImage_tag__3IEph"};